import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Row, Col, Layout, Spin, Breadcrumb,
} from 'antd';
import { Link } from 'react-router-dom';
import { SFCard } from '../../../components/SF-UI';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';
import ManageLeadsTable from './components/ManageLeadsTable';


class Index extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const view_parent_access = views_permissions['view://Leads/Manager_special'];
        if (!view_parent_access) {
            return <NotFound />;
        }
        return (
            <Layout className="lead-manage-container">
                <Spin spinning={this.props.loading} tip="Fetching Leads...">
                    <Row>
                        <Col span={24}>
                            <Breadcrumb className="breadcrumbs">
                                <Breadcrumb.Item><Link to="/Leads/Manage">Leads</Link></Breadcrumb.Item>
                                <Breadcrumb.Item>Manager Special</Breadcrumb.Item>
                            </Breadcrumb>
                            <SFCard className="leadSearch border-shadows">

                                <ManageLeadsTable parent={this} lead_profile_access={!view_parent_access} />
                            </SFCard>
                        </Col>
                    </Row>
                </Spin>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({ views_permissions: state.App.Permissions.views_permissions, loading: state.Leads.Leads_manage.loading });

export default connect(mapStateToProps, null)(checkPermissionsHOC(Index, ['view://Leads/Manager_special']));



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/index.js